var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"funnel",staticStyle:{"width":"560px","height":"600px","box-sizing":"border-box"}})}
var staticRenderFns = []

export { render, staticRenderFns }